module.exports = __webpack_public_path__ + "img/ic_minprogram_instroduce_content.45a4cb21.png";